import { useEffect, useState } from "react";
import { api } from "../api/apiClient";
import { Modal } from "./Modal";

export type ItemImageEnlargeModalProps = {
  itemId: string;
  itemName: string;
  /** G-116: the item's current `imageKey` — versions the address, so a
   *  photo replaced minutes ago is fetched, not the browser's cached one. */
  imageKey: string | null;
  onClose: () => void;
};

export function ItemImageEnlargeModal({
  itemId,
  itemName,
  imageKey,
  onClose,
}: ItemImageEnlargeModalProps) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void api.fetchItemImageBlobUrl(itemId, { version: imageKey }).then((blobUrl) => {
      if (cancelled) return;
      if (!blobUrl) {
        setFailed(true);
        return;
      }
      setUrl(blobUrl);
    });
    return () => {
      cancelled = true;
      api.releaseItemImageBlobUrl(itemId, { version: imageKey });
    };
  }, [itemId, imageKey]);

  return (
    <Modal title={itemName} onClose={onClose}>
      <div className="item-image-enlarge-body">
        {failed ? (
          <p className="muted" style={{ margin: 0 }}>
            Could not load image.
          </p>
        ) : !url ? (
          <p className="muted" style={{ margin: 0 }}>
            Loading…
          </p>
        ) : (
          <img
            src={url}
            alt={itemName}
            className="item-image-enlarge-img"
          />
        )}
      </div>
    </Modal>
  );
}
